module.exports = __webpack_public_path__ + "static/media/self-driven-car.99687bea.jpg";